import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';
import type { IVideo } from '../shared/types';

export const vimeoQuickViewMediatorAtom = mediatorAtom<{ isOpen: boolean; video?: IVideo }>({ isOpen: false });

export default function useVimeoQuickView() {
    return useMediatorState(vimeoQuickViewMediatorAtom);
}
